import 'jquery';
import * as Highcharts from 'highcharts';
import Masonry from 'masonry-layout';
import InfiniteScroll from 'infinite-scroll';
import imagesLoaded from 'imagesloaded';
import Turbolinks from 'turbolinks';

import { Charts } from './charts';
import initProjectPropertyModals from './project-property';
import initProjectEventModals from '../Project/project-event';
import initTeamEditor from './Tabs/team';
import initCarousel from './carousel';
import { Amplitude } from '../Shared/amplitude';
import { Navigation } from '../Shared/navigation';
import UnreadIndicator from './unread-indicator';

import { initDocumentList } from '../Project/document-list';
import { initMediaLinks } from '../Shared/media-links';

import {
	initDealOpportunityModal,
	initDealEditModal,
	initDealShareModal,
	initDealLinkModal,
	initDealDeleteForm,
	trackSignUpButton
} from '../../../Areas/Marketplace/Client/Scripts/Shared/deal-actions';

import '../../../Areas/Marketplace/Client/Styles/Deal/deal-summary.scss';
import ClassicEditor from '../Shared/ckeditor/ckeditor';

export const updateProjectMetricsChart = (project: number) => {
	$.get("/api/chart/metrics?project=" + project, function (chartData) {
		Highcharts.chart('metrics-chart', $.extend(true, chartData, Charts.MetricsChart));
	});
};

export const initProjectNavbar = (msnry: Masonry = null) => {
	var scroll: InfiniteScroll = null;

	var unreadIndicator = new UnreadIndicator($('#project').val() as number);

	const isDealOpportunity = !!$('#deal-key').val();

	initCarousel('#project-content-carousel', isDealOpportunity ? 'Deal' : 'Project', function (hash: string) {
		if (hash == "#News") {
			unreadIndicator.startTracking('news', function () {
				$('.unread-indicator--news').remove();
			});

			if (msnry != null)
				var id = window.setInterval(function () {
					window.clearInterval(id);

					msnry.layout();

					if (scroll == null)
						scroll = new InfiniteScroll(".simplebar-scroll-content", {
							path: "a#more",
							elementScroll: true,
							history: false,
							debug: true
						});
				}, 100);
		}
		else {
			unreadIndicator.stopTracking('news');
		}

		if (hash === '#Highlights') {
			unreadIndicator.startTracking('highlights', function () {
				$('.unread-indicator--highlights').remove();
			});
		}
		else {
			unreadIndicator.stopTracking('highlights');
		}
	});
}

const initInvestmentOpportunityModal = () => {
	$('#investment-opportunity-modal .save-investment-opportunity').click(function (event) {

		var $form = $('#investment-opportunity-form');

		if ($form.validate().form()) {
			$.ajax({
				data: $form.serialize(),
				type: $form.attr('method'),
				url: $form.attr('action'),
				contentType: 'application/x-www-form-urlencoded',
				success: function () {
					var $status = $('#investment-committed-status');

					var amount = $form.find('#Amount').val();
					if (amount)
						$status.find('#investment-amount').text(amount.toString());

					$status.removeClass('d-none');
					$('#investment-opportunity').hide();
					$('#investment-opportunity-modal').modal('hide');
				}
			});
		}
	});

	$('#pass-investment-opportunity-modal .save-investment-opportunity').click(function (event) {

		var $form = $('#pass-investment-opportunity-form');

		if ($form.validate().form()) {
			$.ajax({
				data: $form.serialize(),
				type: $form.attr('method'),
				url: $form.attr('action'),
				contentType: 'application/x-www-form-urlencoded',
				success: function () {
					$('#investment-passed-status').removeClass('d-none');
					$('#investment-opportunity').hide();
					$('#pass-investment-opportunity-modal').modal('hide');
				}
			});
		}
	});
}

const initMetricsUploadForm = () => {
	const $form = $('#upload-metrics-form');
	const $inputFiles = $form.find('#upload-metrics-files');

	$form.find('#upload-metrics-btn').click(function () {
		$inputFiles.click();
	});

	$inputFiles.on('change', function () {
		const fileData = $inputFiles.prop('files')[0];
		const formData = new FormData();
		formData.append('files', fileData);

		$.ajax({
			url: $form.attr('action'),
			dataType: 'text',
			cache: false,
			contentType: false,
			processData: false,
			data: formData,
			type: 'post',
			success: function (response) {
				Navigation.reload();
			},
			error: function (jXHR, textStatus, errorThrown) {
				const $errorMessage = $('<div>').addClass('alert alert-danger alert-dismissible')
					.text(jXHR.responseText)
					.append('<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>');
				$form.prepend($errorMessage);
			}
		});
	});
}

const initPortfolioEventLogic = () => {
	$('.delete-portfolio-event-form').on('submit', function (e) {
		e.preventDefault();

		if (confirm('Are you sure?')) {
			var $this = $(this);
			$.ajax({
				url: $this.attr('action'),
				type: "POST",
				data: $(this).serialize(),
				success: function (data) {
					Navigation.reload();
				}
			});
		}
	});

	$('#new-investment-form').on('submit', function (e) {
		e.preventDefault();

		var $this = $(this);
		$.ajax({
			url: $this.attr('action'),
			type: "POST",
			data: $(this).serialize(),
			success: function (data) {
				window.location.hash = "History";
				Navigation.reload();
			}
		});
	});

	$('#new-portfolio-event-btn').click(function (e) {
		e.preventDefault();

		const $modal = $('#new-portfolio-event-modal');
		const href = $(this).attr('href');

		$.get(href, function (data) {
			$modal.find('.modal-body').empty().html(data);
			$modal.modal();
		});

		const initFormEvents = function () {
			const $amountForm = $('#new-portfolio-event-form.amount')

			$amountForm.find('select#RecordEvent').change(function () {
				switch ($(this).val()) {
					case '21': /* Write Off */
						$amountForm.find('#RecordAmount').attr('disabled', 'disabled');
						break;
					default:
						$amountForm.find('#RecordAmount').removeAttr('disabled');
						break;
				}
			});

			$amountForm.off('submit');

			$amountForm.on('submit', function (e) {
				e.preventDefault();

				$.ajax({
					url: $amountForm.attr('action'),
					type: 'POST',
					data: $amountForm.serialize(),
					success: function (data) {
						$modal.find('.modal-body').empty().html(data);

						const $reviewForm = $modal.find('#new-portfolio-event-form.review');

						if ($reviewForm.length) {
							$amountForm.off('submit');

							$modal.find('.btn-next').addClass('d-none');
							$modal.find('.btn-save').removeClass('d-none');

							$reviewForm.on('submit', function (e) {
								e.preventDefault();

								const $form = $(this);
								$.ajax({
									url: $form.attr('action'),
									type: 'POST',
									data: $form.serialize(),
									success: function (data) {
										$modal.modal('hide');
										Navigation.reload();
									}
								});
							});
						}
						else {
							initFormEvents();
						}
					}
				});
			});
		};

		$modal.on('show.bs.modal', initFormEvents);

		$modal.on('hidden.bs.modal', function () {
			$('#new-portfolio-event-form.amount').off('submit');
			$('#new-portfolio-event-form.review').off('submit');
			$modal.find('.btn-next').removeClass('d-none');
			$modal.find('.btn-save').addClass('d-none');
		});
	});
}

const onLoad = () => {
	const scope = $('#scope').val();
	const scopeMarketplace = $('#scope-marketplace').val();

	if (scope !== 'project' && scopeMarketplace !== 'deal') {
		return;
	}

	const projectKey = $('#project').val();
	const projectName = $('#project-name').val();

	const isDeal = !!$('#deal-key').val();
	const eventName = isDeal ? 'Deal - View' : 'Project - View';

	Amplitude.logEvent(eventName, {
		'Project': projectName
	});

	let msnry: Masonry = null;

	const grid = $('.grid');

	if (grid.length > 0) {

		msnry = new Masonry('.grid', {
			itemSelector: '.grid-item',
			columnWidth: '.grid-sizer',
			percentPosition: true,
			horizontalOrder: false
		});

		imagesLoaded('.grid', function () {
			msnry!.layout();
		});

		$('.simplebar-scroll-content').on('load.infiniteScroll', function (event, response, path) {
			const items = $(response).find('.grid-item');
			items.appendTo('.grid');
			msnry.appended(items.get());
		});

		(<any>window).imagesLoaded = imagesLoaded;
	}

	initProjectNavbar(msnry);
	initInvestmentOpportunityModal();
	initTeamEditor();
	initMetricsUploadForm();
	initPortfolioEventLogic();
	initDocumentList();
	initMediaLinks();
	
	if (projectKey) {
		updateProjectMetricsChart(projectKey as number);
	}

	if (isDeal) {
		initDealOpportunityModal();
		initDealShareModal();
		initDealLinkModal();
		initDealDeleteForm();
		trackSignUpButton();
	}

	import(/* webpackChunkName: "editor" */ '../../Scripts/Shared/ckeditor/ckeditor').then((ClassicEditor: any) => {
		initProjectPropertyModals(ClassicEditor);
		initProjectEventModals(ClassicEditor);

		if (isDeal) {
			initDealEditModal(ClassicEditor);
		}
	});

	$('[data-toggle="tooltip"]').tooltip();
}

$(() => {
	onLoad();
	document.addEventListener('turbolinks:load', onLoad)
});